import { render, staticRenderFns } from "./certificate-authentication.vue?vue&type=template&id=765dad4c&"
import script from "./certificate-authentication.vue?vue&type=script&lang=js&"
export * from "./certificate-authentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports